import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Container, Stack, Tab, Typography } from "@mui/material";
import { useState } from "react";
import useClientPageTitle from "../../contexts/useClientPageTitle";
import ActiveDataSubmissionsList from "./ActiveDataSubmissionsList";
import CompletedDataSubmissionsList from "./CompletedDataSubmissionsList";

type TabValue = "active" | "completed";

const DataCollectionPage = () => {
  useClientPageTitle("Data Collection");

  const [selectedTab, setSelectedTab] = useState<TabValue>("active");

  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Stack spacing={2} sx={{ pt: 2, pb: 1, px: 2, height: "100%" }}>
        <Typography variant="h4">Data Collection</Typography>

        <TabContext value={selectedTab}>
          <TabList onChange={(_, selectedTab: TabValue) => setSelectedTab(selectedTab)}>
            <Tab value="active" label="Active" />
            <Tab value="completed" label="Completed" />
          </TabList>

          <TabPanel value="active" sx={{ height: "100%", pt: 0.5 }}>
            <ActiveDataSubmissionsList />
          </TabPanel>
          <TabPanel value="completed" sx={{ height: "100%", pt: 0.5 }}>
            <CompletedDataSubmissionsList />
          </TabPanel>
        </TabContext>
      </Stack>
    </Container>
  );
};

export default DataCollectionPage;
